import styled from 'styled-components';
import { colors } from '@badi/badi-components';

export const Root = styled.div`
  border: 1px solid ${colors.lightGrey};
  border-radius: 8px;
`;
